
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

import FormInput from '@/components/controls/form-input.vue';
import SubmitButton from '@/components/controls/submit-button.vue';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import Publish from '@/components/forms/publish.vue';
import ImageUploadControl from '@/components/controls/image-upload.vue';
import ProductSelectionControl from '@/components/controls/product-selection.vue';
import MultiSelectInput from '@/components/controls/multiselect-input.vue';
import Autocomplete from '@/components/controls/autocomplete.vue';
import SvgIcon from '@/components/controls/svg-icon.vue';
import ClinicalTrainingEventParticipantsModal from '@/components/layout/clinical-training-event-participants-modal.vue';

import { ClinicalTrainingEventStatus } from '@/store/modules/clinical-training-events/clinical-training-event';
import { ClinicalTrainingEventsActions } from '@/store/modules/clinical-training-events/types';

export default Vue.extend({
  name: 'EditClinicalTrainingEventView',
  inject: {
    $validator: '$validator',
  },
  components: {
    FormInput,
    SubmitButton,
    NotificationBanner,
    Publish,
    ImageUploadControl,
    ProductSelectionControl,
    MultiSelectInput,
    Autocomplete,
  },
  props: {
    add: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productsInput: '',
    };
  },
  computed: {
    ...mapState('clinicalTrainingEvents', {
      event: 'editable',
      editableStatus: 'editableStatus',
      products: 'products',
    }),
    ...mapGetters('clinicalTrainingEvents', {
      isLoading: 'editableIsLoading',
      isSaving: 'editableIsSaving',
      hasUnsavedChanges: 'editableHasUnsavedChanges',
    }),
    isFetching() {
      return this.isLoading || this.isSaving;
    },
    isInactive() {
      return this.event?.status === ClinicalTrainingEventStatus.Inactive;
    },
    getProducts() {
      const selectedIds = this.event.products.map(p => p.id);
      return this.products
        .filter(product => !selectedIds.includes(product.id))
        .filter(product => product.title.toLowerCase().includes(this.productsInput.toLowerCase()))
        .map(product => ({
          label: product.title,
          value: product.id,
        }));
    },
  },
  methods: {
    ...mapActions('clinicalTrainingEvents', {
      updateEditable: ClinicalTrainingEventsActions.UPDATE_EDITABLE,
      save: ClinicalTrainingEventsActions.SAVE,
      removeEvent: ClinicalTrainingEventsActions.DELETE,
      restoreEvent: ClinicalTrainingEventsActions.RESTORE,
      loadEvent: ClinicalTrainingEventsActions.LOAD_EDITABLE,
      loadProducts: ClinicalTrainingEventsActions.LOAD_PRODUCTS,
    }),
    remove() {
      this.removeEvent({ id: this.event.id });
    },
    restore() {
      this.restoreEvent({ id: this.event.id });
    },
    handleSave() {
      this.save();
    },
    removeProduct(id) {
      this.updateEditable({ products: this.event.products.filter(p => p.id !== id) });
    },
    addProduct(option) {
      this.updateEditable({ products: [...this.event.products, { id: option.value, title: option.label }] });
    },
    openParticipantsModal() {
      if (this.event) {
        this.$modal.show(ClinicalTrainingEventParticipantsModal, { event: this.event }, { name: 'clinical-training-event-participants' });
      }
    },
  },
  created() {
    this.loadEvent({ id: this.add ? undefined : this.$route.params.id });
    this.loadProducts();
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      const answer = window.confirm(this.$t('Do you really want to leave? You have unsaved changes!'));
      if (!answer) {
        next(false);
        return;
      }
    }
    next();
  },
});
